let sdkPromise;
let configured = false;

function injectScriptOnce(src) {
    if (sdkPromise) return sdkPromise;

    sdkPromise = new Promise((resolve, reject) => {
        if (window.DNAPayments) return resolve(); // already present

        const el = document.createElement('script');
        el.src = src;
        el.async = true;
        el.onload = () => resolve();
        el.onerror = reject;
        document.head.appendChild(el);
    });

    return sdkPromise;
}

export async function initDnaPayments(dnaPaymentsPaymentAPIJsUrl) {
    console.log("[initDnaPayments] Using dnaPaymentsPaymentAPIJsUrl = ", dnaPaymentsPaymentAPIJsUrl);
    await injectScriptOnce(dnaPaymentsPaymentAPIJsUrl);

    // guard configure so HMR/route changes don’t double-configure
    if (!configured && window.DNAPayments) {
        window.DNAPayments.configure({
            isTestMode: true,
            isEnableDonation: false,
            autoRedirectDelayInMs: 10000,
            events: {
                opened:   () => console.log('[DNA] Checkout opened'),
                cancelled:() => console.log('[DNA] Transaction cancelled'),
                paid:     () => console.log('[DNA] Transaction successful'),
                declined: () => console.log('[DNA] Transaction declined'),
            },
        });
        configured = true;
    }
}

export async function initStripe(stripeJsUrl) {
    console.log("[initStripe] Using stripeJsUrl = ", stripeJsUrl);
    await injectScriptOnce(stripeJsUrl);
}
